<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
    <title>Filtri</title>
    <path
      d="M8.042,17.957c-1.434,0-2.685-.973-3.043-2.367-.026-.098-.116-.168-.218-.168h-2.654c-.342,0-.62-.278-.62-.62s.278-.62.62-.62h2.652c.103,0,.193-.069.218-.168.356-1.394,1.608-2.367,3.044-2.367s2.685.973,3.043,2.367c.026.098.116.168.218.168h8.569c.344,0,.622.278.622.62s-.278.62-.62.62h-8.569c-.103,0-.193.069-.218.168-.356,1.394-1.608,2.367-3.044,2.367ZM8.042,12.889c-1.055,0-1.913.858-1.913,1.913s.858,1.915,1.913,1.915,1.913-.858,1.913-1.913-.858-1.915-1.913-1.915ZM13.956,10.352c-1.433,0-2.684-.974-3.042-2.367-.026-.098-.116-.168-.218-.168H2.127c-.342,0-.62-.278-.62-.62s.278-.62.62-.62h8.567c.103,0,.193-.069.218-.168.356-1.394,1.608-2.367,3.044-2.367s2.685.973,3.044,2.367c.026.098.116.168.218.168h2.654c.342,0,.62.278.62.62s-.278.62-.62.62h-2.654c-.103,0-.193.069-.218.168-.356,1.393-1.607,2.366-3.042,2.367h-.002ZM13.956,5.283c-1.056,0-1.915.859-1.915,1.915s.859,1.915,1.915,1.915,1.915-.859,1.915-1.915-.859-1.915-1.915-1.915Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {};
</script>
